import {ResponseUnknownError} from "../error/response_error";

export const isResponseUnknownError = (error: unknown): error is ResponseUnknownError => {
    return (
        Object.prototype.hasOwnProperty.call(error, "name") &&
        Object.prototype.hasOwnProperty.call(error, "originalError") &&
        Object.prototype.hasOwnProperty.call(error, "url")
    );
};
